import { RootState } from "../../app";

const selectCategorizationAnnotations = (state: RootState) =>
  state.metadataReducer.categorizationState.categorizationAnnotations || [];

export default selectCategorizationAnnotations;
